import { getCurrentCustomerBaskets, sfccSettings } from '../api';
import { SFCCBasket } from '../models/sfcc-basket';
import { addLocaleToBasketUrl } from './add-locale-to-basket-url';

export const makeCurrentBasketAction = async (
  requestPath: string,
  requestMethod: (requestPath: string, body?: unknown) => Promise<SFCCBasket>,
  ensureBasketMethod: () => Promise<SFCCBasket>,
  body?: unknown
): Promise<SFCCBasket> => {
  const baskets = await getCurrentCustomerBaskets();
  let basketId;
  if (baskets.length) {
    basketId = baskets[0].basket_id;
  } else {
    const basket = await ensureBasketMethod();
    basketId = basket.basket_id;
  }

  const url = `/baskets/${basketId}/${requestPath}`;
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);

  return requestMethod(finalUrl, body);
};
